import { render, staticRenderFns } from "./clLabel.vue?vue&type=template&id=7fc9e070"
import script from "./clLabel.vue?vue&type=script&lang=js"
export * from "./clLabel.vue?vue&type=script&lang=js"
import style0 from "./clLabel.vue?vue&type=style&index=0&id=7fc9e070&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports